import React from 'react'
import Layout from '../../layout/default';
import TenantUsageReport from './TenantUsageReport';

const ApiUsage = () => {
  return (
    <Layout>  
        <TenantUsageReport/>
    </Layout>
  )
}

export default ApiUsage